const common = {
    version: "v1",
    locale: "it"
}

const production = {
    baseURL: "https://api.waf.bnesim.com/api",
		baseDomain: "https://api.waf.bnesim.com/",
    websocket_host: "https://waf.bnesim.com",
locale: "en"
}

const local = {
    baseURL: "http://127.0.0.1:8000/api",
    baseDomain: "http://127.0.0.1:8000/",
    websocket_host: "http://127.0.0.1:6002",
    locale: "it"
}

export const environment =  Object.assign(common, process.env.NODE_ENV==='development'?local:production)

